export {}

const generateGalleryId = (gallerySelector: string, galleryLinkSelector: string, postfix = "I") => {
  const galleries = document.querySelectorAll(gallerySelector)
  let galleryId = `gallery-${postfix}`

  galleries.forEach((gallery) => {
    const links = gallery.querySelectorAll(galleryLinkSelector)

    links.forEach((link) => {
      link.setAttribute("data-fancybox", galleryId)
    })
    galleryId += postfix
  })
}
generateGalleryId(".gallery", ".gallery-icon a")
generateGalleryId(".wp-block-gallery", ".blocks-gallery-item a, .wp-block-image a", "W")
generateGalleryId(".s-text-videos", ".s-text-videos__video", "stv")
generateGalleryId(".g-simple-gallery", ".i-simple-gallery", "sgs")
generateGalleryId(".g-gallery-grid", ".i-gallery-grid", "sgg")
